// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3dhL0","active":"downloadDropdown_active__1aEpW"};